import { Box, Button, CardMedia, Typography, LinearProgress } from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import point from "../../logica/ui/img/cursor/point.png";
import { molinoServices, molinoRatiosServices } from "../../services/molinoServices";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc.js";
import { Contador } from "../comun/Contador";
import { rutas } from "../../rutas/rutas";
import { getCookie } from "../../utils/getCookies";
import { setInformacion } from "../../store/slices/usuarios";
import axios from "axios";
import { Alerta } from "../ux/Alert";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { v4 as uuidv4 } from "uuid";
import { motion, AnimatePresence } from "framer-motion";

import { tierras } from "../niveles/tierras";
import { SubirNivelButton } from "../Modales/botones/SubirNivelButton";

dayjs.extend(utc);

const CF_URL = "/favicon.ico";
const SAFE_FALLBACK_ICON =
  "https://res.cloudinary.com/devuvyuij/image/upload/v1680727644/CITYFARMING/image_1_e5q9zu.png";
const TICKET_URL =
  "https://res.cloudinary.com/devuvyuij/image/upload/v1724168023/CITYFARMING/tickets/tikctes-cityfarm_qjujbv.gif";

const MOLINO_ID = 20;
const MOLINO_TIME_MULT = [1.0, 0.8, 0.7, 0.6, 0.5];

const activos = [
  "Corn",
  "Wood",
  "Wheat",
  "Milk",
  "Egg",
  "Corn Bag",
  "Carbon",
  "Wheat Bag",
  "Water",
  "Energy",
];

const activosMolinoFallback = [
  {
    key: "corn_to_corn_bag",
    item: "Corn",
    min: 1,
    max: 20,
    produce: "Corn Bag",
    ratio: 1,
    ratioBase: 1,
    ratioVigente: 1,
    pares: true,
    tiempo: 36,
    costo: 1,
    cripto: false,
    urlProduce:
      "https://res.cloudinary.com/devuvyuij/image/upload/v1680727644/CITYFARMING/image_2_wzvgtv.png",
    wear: 3,
  },
  {
    key: "wheat_to_wheat_bag",
    item: "Wheat",
    min: 1,
    max: 20,
    produce: "Wheat Bag",
    ratio: 1,
    ratioBase: 1,
    ratioVigente: 1,
    pares: false,
    tiempo: 36,
    costo: 1,
    cripto: false,
    urlProduce:
      "https://res.cloudinary.com/devuvyuij/image/upload/v1680727644/CITYFARMING/image_3_imgniw.png",
    wear: 3,
  },
  {
    key: "wood_to_carbon",
    item: "Wood",
    min: 1,
    max: 20,
    produce: "Carbon",
    ratio: 7,
    ratioBase: 7,
    ratioVigente: 7,
    pares: false,
    tiempo: 24,
    costo: 1,
    cripto: false,
    urlProduce:
      "https://res.cloudinary.com/devuvyuij/image/upload/v1680463586/CITYFARMING/carbon_epy7k7.png",
    wear: 2,
  },
  {
    key: "milk_to_cf",
    item: "Milk",
    min: 1,
    max: 20,
    produce: "CF",
    ratio: 150,
    ratioBase: 150,
    ratioVigente: 150,
    pares: true,
    tiempo: 24,
    costo: 1,
    cripto: true,
    urlProduce: CF_URL,
    wear: 4,
  },
  {
    key: "egg_to_cf",
    item: "Egg",
    min: 1,
    max: 20,
    produce: "CF",
    ratio: 150,
    ratioBase: 150,
    ratioVigente: 150,
    pares: true,
    tiempo: 24,
    costo: 1,
    cripto: true,
    urlProduce: CF_URL,
    wear: 4,
  },
  {
    key: "corn_bag_to_cf",
    item: "Corn Bag",
    min: 1,
    max: 20,
    produce: "CF",
    ratio: 40,
    ratioBase: 40,
    ratioVigente: 40,
    pares: true,
    tiempo: 24,
    costo: 1,
    cripto: true,
    urlProduce: CF_URL,
    wear: 5,
  },
  {
    key: "wheat_bag_to_cf",
    item: "Wheat Bag",
    min: 1,
    max: 20,
    produce: "CF",
    ratio: 40,
    ratioBase: 40,
    ratioVigente: 40,
    pares: true,
    tiempo: 24,
    costo: 1,
    cripto: true,
    urlProduce: CF_URL,
    wear: 5,
  },
  {
    key: "carbon_to_cf",
    item: "Carbon",
    min: 1,
    max: 20,
    produce: "CF",
    ratio: 5,
    ratioBase: 5,
    ratioVigente: 5,
    pares: true,
    tiempo: 24,
    costo: 1,
    cripto: true,
    urlProduce: CF_URL,
    wear: 4,
  },
  {
    key: "water_to_cf",
    item: "Water",
    min: 1,
    max: 20,
    produce: "CF",
    ratio: 30,
    ratioBase: 30,
    ratioVigente: 30,
    pares: false,
    tiempo: 24,
    costo: 1,
    cripto: true,
    urlProduce: CF_URL,
    wear: 4,
  },
  {
    key: "energy_to_cf",
    item: "Energy",
    min: 1,
    max: 20,
    produce: "CF",
    ratio: 30,
    ratioBase: 30,
    ratioVigente: 30,
    pares: false,
    tiempo: 24,
    costo: 0,
    cripto: true,
    urlProduce: CF_URL,
    wear: 5,
  },
  {
    key: "cf_to_ticket",
    item: "CF",
    min: 100,
    max: 500,
    produce: "Ticket",
    ratio: 1 / 100,
    ratioBase: 1 / 100,
    ratioVigente: 1 / 100,
    pares: false,
    tiempo: 1,
    costo: 1,
    cripto: false,
    ticket: true,
    urlProduce: TICKET_URL,
    wear: 6,
  },
];

const clamp = (n, a, b) => Math.min(b, Math.max(a, n));
const safeNum = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

function ratioValue(meta) {
  return Number(meta?.ratioVigente ?? meta?.ratio ?? meta?.ratioBase ?? 0);
}

function totalMsForItem(itemName, recetas = activosMolinoFallback) {
  const meta = recetas.find((i) => i.item === itemName);
  const hours = safeNum(meta?.tiempo || 1);
  return hours * 60 * 60 * 1000;
}

function totalMsForJob(job, recetas = activosMolinoFallback) {
  const hours = safeNum(job?.hoursUsed || 0);
  if (hours > 0) return hours * 60 * 60 * 1000;
  return totalMsForItem(job?.item, recetas);
}

function msToPretty(ms) {
  const total = Math.max(0, Math.floor(ms / 1000));

  const days = Math.floor(total / 86400);
  const hours = Math.floor((total % 86400) / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;

  if (days > 0) return `${days}d ${hours}h ${minutes}m`;
  if (hours > 0) return `${hours}h ${minutes}m ${seconds}s`;
  if (minutes > 0) return `${minutes}m ${seconds}s`;
  return `${seconds}s`;
}

const isMillBrokenError = (err) => err?.response?.data?.error === "MILL_BROKEN";

const EMPTY_PET_BENEFIT = {
  active: false,
  reason: "NO_ACTIVE_PET_BENEFIT",
  level: 0,
  stage: "puppy",
  current: null,
  cityFarm: {
    productionBonusPercent: 0,
    waterProductionBonusPercent: 0,
    farmTimeReductionPercent: 0,
    energyTimeReductionPercent: 0,
    millTimeReductionPercent: 0,
  },
};

function normalizePetBenefit(raw) {
  const source = raw && typeof raw === "object" ? raw : {};
  const cityFarm =
    source.cityFarm && typeof source.cityFarm === "object"
      ? source.cityFarm
      : {};

  return {
    active: Boolean(source.active),
    reason: source.reason || (source.active ? "ACTIVE" : "NO_ACTIVE_PET_BENEFIT"),
    level: safeNum(source.level),
    stage: source.stage || "puppy",
    current:
      source.current && typeof source.current === "object"
        ? source.current
        : null,
    cityFarm: {
      productionBonusPercent: safeNum(cityFarm.productionBonusPercent),
      waterProductionBonusPercent: safeNum(
        cityFarm.waterProductionBonusPercent
      ),
      farmTimeReductionPercent: safeNum(
        cityFarm.farmTimeReductionPercent
      ),
      energyTimeReductionPercent: safeNum(
        cityFarm.energyTimeReductionPercent
      ),
      millTimeReductionPercent: safeNum(
        cityFarm.millTimeReductionPercent
      ),
    },
  };
}

function mergePetBenefit(current, incoming) {
  const prev = normalizePetBenefit(current);
  const next = incoming && typeof incoming === "object" ? incoming : {};
  const nextCity =
    next.cityFarm && typeof next.cityFarm === "object"
      ? next.cityFarm
      : {};

  return normalizePetBenefit({
    ...prev,
    ...next,
    cityFarm: {
      ...prev.cityFarm,
      ...nextCity,
    },
  });
}

function OfertaCountdown({ fechaFin }) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  if (!fechaFin) {
    return (
      <Typography sx={{ fontSize: 13, color: "greenyellow" }}>
        Tiempo limitado
      </Typography>
    );
  }

  const fin = new Date(fechaFin).getTime();
  const left = fin - now;

  return (
    <Typography sx={{ fontSize: 13, color: left > 0 ? "greenyellow" : "salmon" }}>
      {left > 0 ? `Termina en ${msToPretty(left)}` : "Oferta finalizada"}
    </Typography>
  );
}

function OfertaMolinoModal({ open, ofertas = [], onClose }) {
  if (!open || !Array.isArray(ofertas) || ofertas.length <= 0) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        zIndex: 10000000000005,
        background:
          "radial-gradient(circle at center, rgba(255,210,90,0.18), rgba(0,0,0,0.78))",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.86, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.25 }}
        style={{ width: "min(560px, 96vw)" }}
      >
        <Box
          className="rpgui-container framed-golden"
          sx={{
            p: 2,
            background: "rgba(0,0,0,0.95)",
            textAlign: "center",
            boxShadow: "0 0 38px rgba(255,210,90,0.32)",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <motion.div
            animate={{ opacity: [0.25, 0.65, 0.25], scale: [1, 1.02, 1] }}
            transition={{ duration: 2.1, repeat: Infinity }}
            style={{
              position: "absolute",
              inset: -20,
              background:
                "radial-gradient(circle at 30% 20%, rgba(255,255,120,0.18), transparent 35%), radial-gradient(circle at 70% 70%, rgba(120,255,120,0.12), transparent 40%)",
              pointerEvents: "none",
            }}
          />

          <Box sx={{ position: "relative", zIndex: 1 }}>
            <Typography sx={{ fontSize: 22, mb: 0.5 }}>
              🔥 Aprovecha estas ofertas
            </Typography>

            <Typography sx={{ fontSize: 13, opacity: 0.86, mb: 1.5 }}>
              El molino tiene ratios especiales activos por tiempo limitado.
            </Typography>

            {ofertas.map((oferta, index) => {
              const ratioBase = safeNum(oferta.ratioBase);
              const ratioOferta = safeNum(oferta.ratioOferta);
              const bonus = safeNum(oferta.bonus || ratioOferta - ratioBase);

              return (
                <motion.div
                  key={oferta.key || index}
                  initial={{ opacity: 0, y: 8 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.07 }}
                >
                  <Box
                    className="rpgui-container framed-grey"
                    sx={{
                      p: 1,
                      mb: 1,
                      textAlign: "left",
                      border: "1px solid rgba(173,255,47,0.25)",
                      background:
                        "linear-gradient(90deg, rgba(60,110,30,0.20), rgba(0,0,0,0.28))",
                    }}
                  >
                    <Box sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}>
                      <Typography sx={{ fontSize: 15 }}>
                        <b>{oferta.item}</b> → {oferta.produce}
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: 11,
                          color: "greenyellow",
                          px: 0.7,
                          py: 0.2,
                          borderRadius: 1,
                          border: "1px solid rgba(173,255,47,0.35)",
                          background: "rgba(0,0,0,0.35)",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {oferta.etiqueta || "OFFER"}
                      </Typography>
                    </Box>

                    <Typography sx={{ fontSize: 13, opacity: 0.92, mt: 0.35 }}>
                      {oferta.mensaje || "Nueva oferta disponible en el molino."}
                    </Typography>

                    <Box
                      sx={{
                        mt: 0.8,
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr 1fr",
                        gap: 0.8,
                      }}
                    >
                      <Box sx={{ textAlign: "center" }}>
                        <Typography sx={{ fontSize: 11, opacity: 0.75 }}>Base</Typography>
                        <Typography sx={{ fontSize: 15 }}>{ratioBase}</Typography>
                      </Box>

                      <Box sx={{ textAlign: "center" }}>
                        <Typography sx={{ fontSize: 11, opacity: 0.75 }}>Oferta</Typography>
                        <Typography sx={{ fontSize: 16, color: "greenyellow" }}>
                          {ratioOferta}
                        </Typography>
                      </Box>

                      <Box sx={{ textAlign: "center" }}>
                        <Typography sx={{ fontSize: 11, opacity: 0.75 }}>Bonus</Typography>
                        <Typography sx={{ fontSize: 15, color: "greenyellow" }}>
                          +{bonus}
                        </Typography>
                      </Box>
                    </Box>

                    <Box sx={{ mt: 0.8, textAlign: "center" }}>
                      <OfertaCountdown fechaFin={oferta.fechaFin} />
                    </Box>
                  </Box>
                </motion.div>
              );
            })}

            <Button className="rpgui-button" onClick={onClose}>
              <p>LET'S MILL</p>
            </Button>
          </Box>
        </Box>
      </motion.div>
    </Box>
  );
}

function MillHUD({
  broken,
  durability,
  serviceWear = 0,
  energyFee = 0,
  repairCostCF = 0,
  cfBalance = 0,
  huesoBalance = 0,
  viphuesoBalance = 0,
  molinoNivel = 1,
  timeMult = 1,
  repairing = false,
  onRepair = null,
}) {
  const dur = clamp(safeNum(durability), 0, 100);
  const low = dur <= 25 && !broken;
  const canRepair = Boolean(onRepair) && (broken || dur < 100);

  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{
        opacity: 1,
        y: 0,
        x: broken ? [0, -2, 2, -1, 1, 0] : low ? [0, -1, 1, 0] : 0,
      }}
      transition={{
        duration: broken ? 0.6 : 0.35,
        repeat: broken ? Infinity : low ? Infinity : 0,
      }}
      style={{ width: "100%" }}
    >
      <Box
        className="rpgui-container framed-grey"
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1.2,
          px: 1.2,
          py: 0.8,
          border: broken
            ? "1px solid rgba(255,70,70,0.35)"
            : low
            ? "1px solid rgba(255,200,90,0.25)"
            : "1px solid rgba(255,255,255,0.10)",
          background: broken
            ? "linear-gradient(90deg, rgba(60,0,0,0.55), rgba(0,0,0,0.25))"
            : "linear-gradient(90deg, rgba(0,0,0,0.25), rgba(0,0,0,0.12))",
          boxShadow: broken
            ? "0 0 22px rgba(255,70,70,0.18)"
            : low
            ? "0 0 18px rgba(255,210,120,0.12)"
            : "none",
          position: "relative",
          overflow: "hidden",
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.0, minWidth: 260 }}>
          <Typography sx={{ fontSize: 12, opacity: 0.9, letterSpacing: "0.06em" }}>
            DURABILITY
          </Typography>

          <Box sx={{ width: 160 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.35 }}>
              <Typography sx={{ fontSize: 11, opacity: 0.85 }}>
                {broken ? "BROKEN" : low ? "LOW" : "OK"}
              </Typography>
              <Typography sx={{ fontSize: 11, opacity: 0.9 }}>{dur.toFixed(0)}%</Typography>
            </Box>

            <LinearProgress
              variant="determinate"
              value={dur}
              sx={{
                height: 9,
                borderRadius: 10,
                backgroundColor: "rgba(255,255,255,0.06)",
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.35)",
              }}
            />
          </Box>

          <motion.div
            animate={{
              opacity: [0.2, broken ? 1 : 0.75, 0.2],
              scale: broken ? [1, 1.2, 1] : [1, 1.08, 1],
            }}
            transition={{ duration: broken ? 0.6 : 1.1, repeat: Infinity }}
            style={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              background: broken
                ? "rgba(255,80,80,0.95)"
                : low
                ? "rgba(255,200,90,0.95)"
                : "rgba(60,180,110,0.95)",
              boxShadow: broken
                ? "0 0 14px rgba(255,80,80,0.7)"
                : low
                ? "0 0 14px rgba(255,200,90,0.55)"
                : "0 0 14px rgba(60,180,110,0.45)",
            }}
          />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1.0, flexWrap: "wrap" }}>
          {[
            `Service wear: -${safeNum(serviceWear)}%`,
            `Energy fee: ${safeNum(energyFee)}`,
            `Level: ${safeNum(molinoNivel)} · Speed x${(1 / safeNum(timeMult || 1)).toFixed(2)}`,
          ].map((txt) => (
            <Box
              key={txt}
              sx={{
                px: 0.9,
                py: 0.25,
                borderRadius: 10,
                background: "rgba(0,0,0,0.28)",
                border: "1px solid rgba(255,255,255,0.08)",
              }}
            >
              <Typography sx={{ fontSize: 12, opacity: 0.9 }}>{txt}</Typography>
            </Box>
          ))}
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, flexWrap: "wrap", justifyContent: "flex-end" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.6 }}>
            <CardMedia component="img" image={CF_URL} sx={{ width: 18, height: 18, objectFit: "contain" }} />
            <Typography sx={{ fontSize: 12, opacity: 0.95 }}>
              CF: <b>{safeNum(cfBalance)}</b>
            </Typography>
          </Box>

          <Typography sx={{ fontSize: 12, opacity: 0.95 }}>
            HUESO: <b>{safeNum(huesoBalance)}</b>
          </Typography>

          <Typography sx={{ fontSize: 12, opacity: 0.95 }}>
            VIPHUESO: <b>{safeNum(viphuesoBalance)}</b>
          </Typography>

          <motion.div
            initial={{ opacity: 0, x: 6 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.18 }}
            style={{ display: "flex", alignItems: "center", gap: 10 }}
          >
            {safeNum(repairCostCF) > 0 && (
              <Typography sx={{ fontSize: 12, opacity: 0.95 }}>
                Repair cost: <b>{safeNum(repairCostCF)}</b> CF
              </Typography>
            )}

            <motion.div whileTap={{ scale: 0.97 }} whileHover={{ scale: 1.02 }}>
              <Button
                className="rpgui-button"
                onClick={canRepair ? onRepair : undefined}
                disabled={!canRepair || repairing}
              >
                <p>{repairing ? "Repairing..." : "Repair"}</p>
              </Button>
            </motion.div>
          </motion.div>
        </Box>
      </Box>
    </motion.div>
  );
}


function PetBenefitsPanel({ benefit }) {
  const data = normalizePetBenefit(benefit);
  const city = data.cityFarm;
  const active = Boolean(data.active);

  const benefits = [
    {
      icon: "🌾",
      label: "Farm time",
      value: `-${safeNum(city.farmTimeReductionPercent)}%`,
      description: "Crops, trees and animals finish sooner.",
    },
    {
      icon: "💧",
      label: "Water production",
      value: `+${safeNum(city.waterProductionBonusPercent)}%`,
      description: "Extra Water is received when collecting.",
    },
    {
      icon: "⚡",
      label: "Energy cycle",
      value: `-${safeNum(city.energyTimeReductionPercent)}%`,
      description: "Energy production cycles finish sooner.",
    },
    {
      icon: "⚙️",
      label: "Mill time",
      value: `-${safeNum(city.millTimeReductionPercent)}%`,
      description: "Mill processing finishes sooner.",
    },
    {
      icon: "🌱",
      label: "Production bonus",
      value: `+${safeNum(city.productionBonusPercent)}%`,
      description: "General City Farm production benefit.",
    },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: -6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.22 }}
      style={{ width: "100%" }}
    >
      <Box
        className="rpgui-container framed-grey"
        sx={{
          width: "100%",
          p: 1.1,
          border: active
            ? "1px solid rgba(173,255,47,0.28)"
            : "1px solid rgba(255,180,90,0.22)",
          background: active
            ? "linear-gradient(90deg, rgba(50,110,30,0.20), rgba(0,0,0,0.28))"
            : "linear-gradient(90deg, rgba(120,70,20,0.18), rgba(0,0,0,0.28))",
          boxShadow: active
            ? "0 0 18px rgba(173,255,47,0.10)"
            : "none",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 1,
            flexWrap: "wrap",
            mb: 0.9,
          }}
        >
          <Box>
            <Typography sx={{ fontSize: 14 }}>
              🐾 Pet benefits
            </Typography>

            <Typography sx={{ fontSize: 11, opacity: 0.78 }}>
              {active
                ? `Active pet · Level ${safeNum(data.level)} · ${data.stage}`
                : `Inactive · ${data.reason || "NO_ACTIVE_PET_BENEFIT"}`}
            </Typography>
          </Box>

          <Box
            sx={{
              px: 0.9,
              py: 0.35,
              borderRadius: 10,
              border: active
                ? "1px solid rgba(173,255,47,0.35)"
                : "1px solid rgba(255,160,90,0.30)",
              background: active
                ? "rgba(90,150,40,0.18)"
                : "rgba(140,70,20,0.18)",
            }}
          >
            <Typography
              sx={{
                fontSize: 11,
                color: active ? "greenyellow" : "salmon",
              }}
            >
              {active ? "ACTIVE" : "NO BONUS"}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, minmax(0, 1fr))",
              lg: "repeat(5, minmax(0, 1fr))",
            },
            gap: 0.75,
          }}
        >
          {benefits.map((item) => (
            <Box
              key={item.label}
              sx={{
                minWidth: 0,
                p: 0.75,
                borderRadius: 1,
                border: "1px solid rgba(255,255,255,0.08)",
                background: "rgba(0,0,0,0.24)",
                opacity: active ? 1 : 0.72,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 0.7,
                }}
              >
                <Typography sx={{ fontSize: 12 }}>
                  {item.icon} {item.label}
                </Typography>

                <Typography
                  sx={{
                    fontSize: 13,
                    color:
                      active && safeNum(item.value.replace(/[^0-9.-]/g, "")) > 0
                        ? "greenyellow"
                        : "rgba(255,255,255,0.72)",
                    whiteSpace: "nowrap",
                  }}
                >
                  <b>{active ? item.value : "0%"}</b>
                </Typography>
              </Box>

              <Typography
                sx={{
                  fontSize: 10,
                  opacity: 0.68,
                  mt: 0.35,
                  lineHeight: 1.25,
                }}
              >
                {item.description}
              </Typography>
            </Box>
          ))}
        </Box>

        {data.current && (
          <Box
            sx={{
              mt: 0.85,
              display: "flex",
              gap: 0.7,
              flexWrap: "wrap",
            }}
          >
            {[
              `Hunger ${safeNum(data.current.hunger)}`,
              `Thirst ${safeNum(data.current.thirst)}`,
              `Happiness ${safeNum(data.current.happiness)}`,
              `Health ${safeNum(data.current.health)}`,
              `Life ${safeNum(data.current.life)}`,
            ].map((value) => (
              <Box
                key={value}
                sx={{
                  px: 0.7,
                  py: 0.2,
                  borderRadius: 8,
                  background: "rgba(0,0,0,0.25)",
                  border: "1px solid rgba(255,255,255,0.07)",
                }}
              >
                <Typography sx={{ fontSize: 10, opacity: 0.82 }}>
                  {value}
                </Typography>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </motion.div>
  );
}

function MillScene({ running, broken = false, produceUrl, title = "MILL", subtitle = "" }) {
  const safeProduce = produceUrl || CF_URL || SAFE_FALLBACK_ICON;

  return (
    <Box
      className="rpgui-container framed-grey"
      sx={{
        position: "relative",
        overflow: "hidden",
        minHeight: 220,
        p: 1.6,
        boxShadow: broken
          ? "0 0 0 1px rgba(255,60,60,0.22), 0 0 36px rgba(255,60,60,0.22)"
          : running
          ? "0 0 0 1px rgba(255,220,140,0.20), 0 0 28px rgba(255,220,140,0.18)"
          : "0 0 0 1px rgba(0,0,0,0.25)",
        transition: "box-shadow 250ms ease",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          opacity: broken ? 0.55 : 0.35,
          background: broken
            ? "radial-gradient(circle at 20% 20%, rgba(255,40,40,0.18), transparent 45%), radial-gradient(circle at 70% 40%, rgba(255,140,80,0.10), transparent 52%), linear-gradient(180deg, rgba(0,0,0,0.35), rgba(0,0,0,0.62))"
            : "radial-gradient(circle at 20% 20%, rgba(255,255,255,0.12), transparent 40%), radial-gradient(circle at 70% 40%, rgba(255,210,120,0.10), transparent 45%), linear-gradient(180deg, rgba(0,0,0,0.20), rgba(0,0,0,0.45))",
          pointerEvents: "none",
        }}
      />

      <motion.div
        animate={
          broken
            ? { x: [0, -2, 2, -1, 1, 0], rotate: [0, -0.2, 0.2, -0.1, 0.1, 0] }
            : { x: 0, rotate: 0 }
        }
        transition={broken ? { duration: 0.6, repeat: Infinity } : { duration: 0.2 }}
        style={{
          position: "absolute",
          left: 14,
          bottom: 10,
          width: 150,
          height: 200,
          borderRadius: "10px",
          background: broken
            ? "linear-gradient(180deg, rgba(170,90,70,0.60), rgba(70,25,25,0.78))"
            : "linear-gradient(180deg, rgba(210,150,90,0.55), rgba(120,70,35,0.65))",
          boxShadow: "inset 0 0 0 2px rgba(0,0,0,0.35)",
          filter: broken ? "contrast(1.08) saturate(0.85)" : "none",
        }}
      />

      <motion.div
        animate={broken ? { rotate: [0, 10, -12, 9, -8, 0] } : running ? { rotate: 360 } : { rotate: 0 }}
        transition={
          broken
            ? { duration: 0.8, repeat: Infinity }
            : running
            ? { duration: 1.1, repeat: Infinity, ease: "linear" }
            : { duration: 0.4 }
        }
        style={{
          position: "absolute",
          left: 132,
          bottom: 110,
          width: 132,
          height: 132,
          transformOrigin: "50% 50%",
          filter: broken ? "drop-shadow(0 0 10px rgba(255,60,60,0.25)) grayscale(0.2)" : "none",
        }}
      >
        {[0, 90, 180, 270].map((deg) => (
          <Box
            key={deg}
            sx={{
              position: "absolute",
              left: "50%",
              top: "50%",
              width: 11,
              height: 62,
              borderRadius: "6px",
              transform: `translate(-50%, -100%) rotate(${deg}deg)`,
              transformOrigin: "50% 100%",
              background: broken
                ? "linear-gradient(180deg, rgba(255,190,190,0.25), rgba(120,120,120,0.45))"
                : "linear-gradient(180deg, rgba(240,240,240,0.65), rgba(160,160,160,0.55))",
              boxShadow: "inset 0 0 0 2px rgba(0,0,0,0.25)",
            }}
          />
        ))}

        <Box
          sx={{
            position: "absolute",
            left: "50%",
            top: "50%",
            width: 22,
            height: 22,
            borderRadius: "50%",
            transform: "translate(-50%, -50%)",
            background: broken ? "rgba(255,60,60,0.10)" : "rgba(0,0,0,0.35)",
            boxShadow: broken
              ? "inset 0 0 0 2px rgba(255,60,60,0.22)"
              : "inset 0 0 0 2px rgba(255,255,255,0.08)",
          }}
        />
      </motion.div>

      <Box sx={{ position: "absolute", right: 14, bottom: 10, textAlign: "center" }}>
        <Typography sx={{ fontSize: 13, opacity: 0.95 }}>{broken ? "MILL DAMAGED" : title}</Typography>

        {subtitle ? (
          <Typography sx={{ fontSize: 11, opacity: 0.75 }}>
            {broken ? "Repair required" : subtitle}
          </Typography>
        ) : null}

        <Box sx={{ display: "flex", gap: 1.1, alignItems: "center", justifyContent: "center", mt: 1 }}>
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: "10px",
              background: "rgba(0,0,0,0.22)",
              border: broken
                ? "1px solid rgba(255,60,60,0.35)"
                : running
                ? "1px solid rgba(255,220,140,0.35)"
                : "1px solid rgba(255,255,255,0.08)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 250ms ease",
              filter: broken ? "grayscale(0.75) contrast(1.05) brightness(0.9)" : "none",
            }}
          >
            <CardMedia
              component="img"
              image={safeProduce}
              sx={{ width: 58, height: 58, objectFit: "contain", imageRendering: "pixelated" }}
            />
          </Box>

          {(running || broken) && (
            <motion.div
              animate={{ opacity: [0.2, broken ? 1 : 0.85, 0.2] }}
              transition={{ duration: broken ? 0.7 : 1.2, repeat: Infinity }}
              style={{
                width: 9,
                height: 9,
                borderRadius: "50%",
                background: broken ? "rgba(255, 80, 80, 0.95)" : "rgba(255, 230, 140, 0.9)",
                boxShadow: broken
                  ? "0 0 14px rgba(255, 80, 80, 0.7)"
                  : "0 0 12px rgba(255, 230, 140, 0.7)",
              }}
            />
          )}
        </Box>
      </Box>

      {broken && (
        <Box
          sx={{
            position: "absolute",
            left: 12,
            top: 12,
            px: 1,
            py: 0.6,
            borderRadius: 1,
            background: "rgba(120,0,0,0.35)",
            border: "1px solid rgba(255,70,70,0.30)",
            backdropFilter: "blur(2px)",
          }}
        >
          <Typography sx={{ fontSize: 12, opacity: 0.95 }}>
            ⚠️ Broken — press <b>Repair</b> to unlock processing
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export const Molino = ({ handleClose4 }) => {
  const { informacion } = useSelector((state) => state.userSlice);

  const [selector, setSelector] = useState("CF");
  const [cantidad, setCantidad] = useState(0);
  const [monto, setMonto] = useState(0);
  const [pagina, setPagina] = useState(0);
  const [activosMolinoData, setActivos] = useState([]);
  const [error, setError] = useState(false);
  const [open, setOpen] = useState(false);
  const [mensaje, setMensaje] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [kickMs, setKickMs] = useState(0);

  const [millBroken, setMillBroken] = useState(false);
  const [millDur, setMillDur] = useState(100);
  const [repairCostCF, setRepairCostCF] = useState(0);
  const [repairing, setRepairing] = useState(false);

  const [ratiosMolino, setRatiosMolino] = useState([]);
  const [ofertasMolino, setOfertasMolino] = useState([]);
  const [openOferta, setOpenOferta] = useState(false);
  const [ratiosLoaded, setRatiosLoaded] = useState(false);
  const [petBenefit, setPetBenefit] = useState(() =>
    normalizePetBenefit(EMPTY_PET_BENEFIT)
  );

  // ✅ Evita que el popup automático se abra varias veces en la misma entrada al molino.
  // El botón Offers puede abrirlo manualmente siempre.
  const autoOfertaMostradaRef = useRef(false);

  const dispatch = useDispatch();

  const molinoNivel = clamp(safeNum(informacion?.molinoNivel || 1), 1, 5);
  const timeMult = MOLINO_TIME_MULT[molinoNivel - 1] ?? 1;

  const cfBalance = safeNum(informacion?.cf ?? 0);
  const huesoBalance = safeNum(informacion?.hueso ?? 0);
  const viphuesoBalance = safeNum(
    informacion?.viphueso ?? informacion?.vipHueso ?? informacion?.VIPHUESO ?? 0
  );

  const petCityFarm = normalizePetBenefit(petBenefit).cityFarm;
  const petMillTimeReductionPercent = petBenefit?.active
    ? safeNum(petCityFarm.millTimeReductionPercent)
    : 0;

  const recetasMolino = useMemo(() => {
    if (Array.isArray(ratiosMolino) && ratiosMolino.length > 0) {
      return ratiosMolino.map((r) => ({
        ...r,
        ratio: ratioValue(r),
        ratioVigente: ratioValue(r),
        urlProduce: r.urlProduce || (r.produce === "Ticket" ? TICKET_URL : CF_URL),
      }));
    }

    return activosMolinoFallback;
  }, [ratiosMolino]);

  const LEVEL_IMAGES = useMemo(
    () => [
      "https://res.cloudinary.com/dpwv380jp/image/upload/v1767752471/LVL_1_hobgtm.png",
      "https://res.cloudinary.com/dpwv380jp/image/upload/v1767752471/LVL2_crp4nw.png",
      "https://res.cloudinary.com/dpwv380jp/image/upload/v1767752474/LVL3_r6c5dh.png",
      "https://res.cloudinary.com/dpwv380jp/image/upload/v1767752473/LVL4_ymzyk5.png",
      "https://res.cloudinary.com/dpwv380jp/image/upload/v1767752473/LVL5_ppgq3x.png",
    ],
    []
  );

  const landCfg = useMemo(() => tierras.find((t) => t.id === MOLINO_ID), []);
  const [previewLevel, setPreviewLevel] = useState(molinoNivel);

  useEffect(() => setPreviewLevel(molinoNivel), [molinoNivel]);

  const maxLevel = LEVEL_IMAGES?.length || 5;
  const nextLevelReal = Math.min(molinoNivel + 1, maxLevel);

  const reqForPreviewLevel = useMemo(() => {
    if (!landCfg?.nivel) return null;
    if (previewLevel <= 1) return null;
    const idx = previewLevel - 2;
    return landCfg.nivel[idx] || null;
  }, [landCfg, previewLevel]);

  const metaSel = useMemo(() => {
    return (
      recetasMolino.find((i) => i.item === selector) ||
      recetasMolino.find((i) => i.item === "CF") ||
      activosMolinoFallback.find((i) => i.item === "CF")
    );
  }, [selector, recetasMolino]);

  const produceImg = metaSel?.urlProduce || CF_URL || SAFE_FALLBACK_ICON;
  const serviceWear = safeNum(metaSel?.wear || 0);
  const energyFee = safeNum(metaSel?.costo || 0);

  const effectiveHoursUI = useMemo(() => {
    const base = safeNum(metaSel?.tiempo || 1);
    const afterMillLevel = base * timeMult;
    const afterPet =
      afterMillLevel * (1 - petMillTimeReductionPercent / 100);

    return Math.max(0.05, afterPet);
  }, [
    metaSel?.tiempo,
    timeMult,
    petMillTimeReductionPercent,
  ]);

  const abrirOfertaAutomatica = (ofertas = [], delay = 350) => {
    if (autoOfertaMostradaRef.current) return;
    if (!Array.isArray(ofertas) || ofertas.length <= 0) return;

    autoOfertaMostradaRef.current = true;

    setTimeout(() => {
      setOpenOferta(true);
    }, delay);
  };

  const cargarRatiosMolino = async ({ showOffer = true } = {}) => {
    try {
      const resp = await molinoRatiosServices();
      const ratios = resp?.data?.ratios || [];
      const ofertas = resp?.data?.ofertas || [];

      if (Array.isArray(ratios) && ratios.length > 0) {
        setRatiosMolino(ratios);
      }

      if (Array.isArray(ofertas)) {
        setOfertasMolino(ofertas);

        if (showOffer && ofertas.length > 0) {
          abrirOfertaAutomatica(ofertas);
        }
      }
    } catch (err) {
      console.warn("[MOLINO] No se pudieron cargar ratios desde MongoDB. Usando fallback.", err);
    } finally {
      setRatiosLoaded(true);
    }
  };

  const getMolinos = async () => {
    try {
      const resp = await molinoServices();
      const payload = resp?.data;


      if (Array.isArray(payload?.ratios) && payload.ratios.length > 0) {
  setRatiosMolino(payload.ratios);
}

      if (Array.isArray(payload?.ofertas)) {
        setOfertasMolino(payload.ofertas);
        abrirOfertaAutomatica(payload.ofertas);
      }

      if (Array.isArray(payload)) {
        setActivos(payload || []);
        setMillBroken(false);
        setMillDur(100);
        setRepairCostCF(0);
        setPetBenefit(normalizePetBenefit(EMPTY_PET_BENEFIT));
        return;
      }

      const st = payload?.state;
      const data = payload?.data;
      const loadedPetBenefit = normalizePetBenefit(payload?.petBenefit);

      setActivos(data || []);
      setMillDur(safeNum(st?.durabilidad ?? 100));
      setMillBroken(Boolean(st?.roto));
      setRepairCostCF(safeNum(payload?.repairCostCF ?? st?.repairCostCF ?? 0));
      setPetBenefit(loadedPetBenefit);

      console.log("[MOLINO][PET BENEFIT]", loadedPetBenefit);
    } catch (err) {
      if (isMillBrokenError(err)) {
        const d = err?.response?.data || {};
        setMillBroken(true);
        setMillDur(safeNum(d?.durabilidad ?? 0));
        setRepairCostCF(safeNum(d?.repairCostCF ?? 0));
        setActivos([]);
        return;
      }

      setActivos([]);
    }
  };

  useEffect(() => {
    cargarRatiosMolino({ showOffer: true });
    getMolinos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ✅ Si las ofertas llegan por /api/verMolino/ en vez de /api/molino/ratios,
  // también abre el popup automáticamente al entrar al molino.
  useEffect(() => {
    abrirOfertaAutomatica(ofertasMolino);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ofertasMolino]);

  useEffect(() => {
    if (pagina === 1) getMolinos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagina]);

  useEffect(() => {
    if (cantidad && Number(cantidad) > 0) {
      handleCantidad();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [metaSel?.ratioVigente, metaSel?.ratio, selector, ratiosLoaded]);

  const hasJobs = useMemo(() => (activosMolinoData?.length || 0) > 0, [activosMolinoData]);
  const running = !millBroken && (isSubmitting || kickMs > Date.now() || hasJobs);

  const handleCantidad = () => {
    const item = metaSel;
    if (!item) return;

    const cantNum = Number(cantidad);
    if (!selector || cantNum > item?.max || cantNum < item?.min) {
      setCantidad(0);
      setMonto(0);
      return;
    }

    const min = safeNum(item?.min || 1) || 1;
    const cantidadValida = cantNum % min === 0 ? cantNum : cantNum - (cantNum % min);
    const ratio = ratioValue(item);

    setCantidad(cantidadValida);
    setMonto(Number((ratio * cantidadValida).toFixed(8)));
  };

  const procesar = async () => {
    if (millBroken) {
      setError(true);
      setOpen(true);
      setMensaje("MILL_BROKEN");
      return;
    }

    if (Number(cantidad) <= 0) {
      setError(true);
      setOpen(true);
      setMensaje("INVALID_QUANTITY");
      return;
    }

    try {
      setIsSubmitting(true);
      setKickMs(Date.now() + 2500);

      await cargarRatiosMolino({ showOffer: false });

      const processResponse = await molinoServices("post", {
        item: selector,
        cantidad: Number(cantidad),
      });

      const usuario = processResponse?.data?.usuario;
      const processPetBenefit = processResponse?.data?.petBenefit;

      if (processPetBenefit) {
        setPetBenefit((current) =>
          mergePetBenefit(current, {
            active: processPetBenefit.active,
            level: processPetBenefit.level,
            cityFarm: {
              millTimeReductionPercent:
                processPetBenefit.millTimeReductionPercent,
            },
          })
        );
      }

      setError(false);
      if (usuario) dispatch(setInformacion(usuario));
      setMensaje("SUCCESS");
      setOpen(true);

      await getMolinos();
    } catch (error) {
      if (isMillBrokenError(error)) {
        const d = error?.response?.data || {};
        setMillBroken(true);
        setMillDur(safeNum(d?.durabilidad ?? 0));
        setRepairCostCF(safeNum(d?.repairCostCF ?? 0));
        setError(true);
        setOpen(true);
        setMensaje("MILL_BROKEN");
        return;
      }

      setError(true);
      setOpen(true);
      setMensaje(error?.response?.data?.error || "ERROR");
    } finally {
      setIsSubmitting(false);
    }
  };

  const reclamar = async (id) => {
    try {
      await molinoServices("post", { id }, false);

      const tokenJWT = getCookie("token");
      if (tokenJWT) {
        axios.get(`${rutas.getUsuario}`, { headers: { token: tokenJWT } }).then(({ data }) => {
          getMolinos();
          dispatch(setInformacion(data));
        });
      }

      setError(false);
      setMensaje("SUCCESS");
      setOpen(true);
    } catch (error) {
      setError(true);
      setOpen(true);
      setMensaje(error?.response?.data?.error || "ERROR");
    }
  };

  const reparar = async () => {
    try {
      setRepairing(true);

      const resp = await molinoServices("post", {}, true, "reparar");

      const usuario = resp?.data?.usuario;
      const state = resp?.data?.state;

      if (usuario) dispatch(setInformacion(usuario));

      setMillBroken(false);
      setMillDur(safeNum(state?.durabilidad ?? 100));
      setRepairCostCF(0);

      setError(false);
      setMensaje("REPAIRED ✅");
      setOpen(true);

      getMolinos();
    } catch (err) {
      setError(true);
      setOpen(true);
      setMensaje(err?.response?.data?.error || "ERROR");
    } finally {
      setRepairing(false);
    }
  };

  const renderJobCard = (job) => {
    const msLeft = dayjs(job?.tiempo).diff(dayjs(), "millisecond");
    const totalMs = totalMsForJob(job, recetasMolino);
    const progress = clamp(1 - msLeft / totalMs, 0, 1);
    const ready = msLeft <= 0;

    return (
      <motion.div
        key={job._id || uuidv4()}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2 }}
        style={{ width: "100%" }}
      >
        <Box
          sx={{
            minWidth: "320px",
            minHeight: "116px",
            height: "auto",
            width: "100%",
            py: 1,
            display: "flex",
            justifyContent: "space-between",
            gap: 2,
            alignItems: "center",
          }}
          className="rpgui-container framed-golden"
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <Typography sx={{ m: 0, fontSize: { xs: "0.98rem", md: "1.05rem" } }}>
              {job.item} → <span style={{ opacity: 0.85 }}>{job.produce}</span>{" "}
              {ready ? (
                <span
                  style={{
                    marginLeft: 8,
                    fontSize: 12,
                    padding: "2px 6px",
                    borderRadius: 8,
                    background: "rgba(60,180,110,0.18)",
                    border: "1px solid rgba(60,180,110,0.30)",
                  }}
                >
                  READY
                </span>
              ) : null}
            </Typography>

            <Typography sx={{ m: 0, opacity: 0.85 }}>
              Ratio: {job.ratio} · Reward: {job.ganancia}
            </Typography>

            {job?.petBenefitActive &&
              safeNum(job?.petTimeReductionPercent) > 0 && (
                <Typography
                  sx={{
                    m: 0,
                    fontSize: 11,
                    color: "greenyellow",
                    opacity: 0.92,
                  }}
                >
                  🐾 Pet LVL {safeNum(job?.petLevel)} · Time -
                  {safeNum(job?.petTimeReductionPercent)}% · Final{" "}
                  {safeNum(job?.hoursUsed).toFixed(2)}h
                </Typography>
              )}

            <Box sx={{ width: 220, mt: 0.5 }}>
              <LinearProgress
                variant="determinate"
                value={progress * 100}
                sx={{
                  height: 10,
                  borderRadius: 6,
                  backgroundColor: "rgba(255,255,255,0.06)",
                  boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.35)",
                }}
              />

              <Typography sx={{ fontSize: 12, opacity: 0.8, mt: 0.5 }}>
                {ready ? "READY ✅" : `Processing… ${(progress * 100).toFixed(0)}%`}
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Contador segundos={job?.tiempo} />

            {ready && (
              <motion.div animate={{ scale: [1, 1.05, 1] }} transition={{ duration: 0.8, repeat: Infinity }}>
                <Button onClick={() => reclamar(job._id)} className="rpgui-button">
                  <p>Claim</p>
                </Button>
              </motion.div>
            )}
          </Box>
        </Box>
      </motion.div>
    );
  };

  return (
    <Grid2 container spacing={2} sx={{ height: "100%", position: "relative" }}>
      <OfertaMolinoModal
        open={openOferta}
        ofertas={ofertasMolino}
        onClose={() => setOpenOferta(false)}
      />

      <Box
        onClick={() => {
          setOpenOferta(false);
          autoOfertaMostradaRef.current = false;
          handleClose4();
        }}
        sx={{
          position: "absolute",
          right: 8,
          top: 6,
          zIndex: 10000000000001,
          color: "gray",
          cursor: "pointer",
          userSelect: "none",
          opacity: 0.9,
          "&:hover": { opacity: 1 },
        }}
      >
        X
      </Box>

      <Grid2 xs={12} sx={{ width: "100%" }}>
        <MillHUD
          broken={millBroken}
          durability={millDur}
          serviceWear={serviceWear}
          energyFee={energyFee}
          repairCostCF={repairCostCF}
          cfBalance={cfBalance}
          huesoBalance={huesoBalance}
          viphuesoBalance={viphuesoBalance}
          molinoNivel={molinoNivel}
          timeMult={timeMult}
          onRepair={reparar}
          repairing={repairing}
        />
      </Grid2>

      <Grid2 xs={12} sx={{ width: "100%" }}>
        <PetBenefitsPanel benefit={petBenefit} />
      </Grid2>

      <Grid2 xs={12} className="rpgui-container framed-golden" sx={{ width: "100%" }}>
        <Button onClick={() => setPagina(0)} className="rpgui-button">
          <p>Processor</p>
        </Button>
        <Button onClick={() => setPagina(1)} className="rpgui-button">
          <p>Materials in process</p>
        </Button>

        {ofertasMolino.length > 0 && (
          <Button onClick={() => setOpenOferta(true)} className="rpgui-button">
            <p>Offers</p>
          </Button>
        )}
      </Grid2>

      {pagina === 1 && (
        <Box
          sx={{
            height: "75%",
            width: "100%",
            position: "relative",
            display: "flex",
            overflow: "auto",
            flexDirection: "column",
            gap: 1,
          }}
          className="rpgui-container framed-golden-2"
        >
          {!millBroken ? (
            <AnimatePresence>{activosMolinoData.map((job) => renderJobCard(job))}</AnimatePresence>
          ) : (
            <Box className="rpgui-container framed-grey" sx={{ p: 2 }}>
              <Typography sx={{ fontSize: 18, mb: 1 }}>⚠️ MILL BROKEN</Typography>
              <Typography sx={{ opacity: 0.85, mb: 1.5 }}>
                Processing is disabled. Repair is available in the top HUD.
              </Typography>
            </Box>
          )}
        </Box>
      )}

      {pagina === 0 && (
        <Box
          sx={{
            height: "75%",
            width: "100%",
            position: "relative",
            display: "flex",
            overflow: "auto",
            flexDirection: { xs: "column", md: "row" },
            gap: 1.6,
          }}
          className="rpgui-container framed-golden-2"
        >
          <Grid2
            container
            columns={{ xs: 2, md: 2 }}
            sx={{
              overflow: "auto",
              minHeight: 280,
              maxWidth: { xs: "100%", md: 320 },
              pr: 0.5,
            }}
            xs={12}
            md={3}
          >
            <Box
              key={"CF"}
              onClick={() => setSelector("CF")}
              className={selector === "CF" ? "rpgui-container framed-golden" : "rpgui-container framed-grey"}
              sx={{
                cursor: `url(${point}) 10 0, auto`,
                border: "1px solid gray",
                width: { xs: "100%", md: 150 },
                height: 70,
                boxShadow: selector === "CF" ? "0 0 18px rgba(255,220,140,0.18)" : "none",
                transition: "box-shadow 200ms ease",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                pr: 1,
              }}
            >
              <Typography sx={{ fontSize: 13 }}>CF - {cfBalance}</Typography>
              <CardMedia component="img" image={CF_URL} sx={{ width: 18, height: 18, objectFit: "contain" }} />
            </Box>

            {activos.map((nombre) => {
              const i = informacion?.inventario?.find((it) => it?.item === nombre);
              const receta = recetasMolino.find((r) => r.item === nombre);
              const oferta = ofertasMolino.find((o) => o.item === nombre);
              const enOferta = Boolean(oferta);

              return (
                <Box
                  key={nombre}
                  onClick={() => setSelector(nombre)}
                  className={selector === nombre ? "rpgui-container framed-golden" : "rpgui-container framed-grey"}
                  sx={{
                    cursor: `url(${point}) 10 0, auto`,
                    border: enOferta ? "1px solid rgba(173,255,47,0.65)" : "1px solid gray",
                    width: { xs: "100%", md: 150 },
                    height: 70,
                    boxShadow:
                      selector === nombre
                        ? "0 0 18px rgba(255,220,140,0.18)"
                        : enOferta
                        ? "0 0 14px rgba(173,255,47,0.15)"
                        : "none",
                    transition: "box-shadow 200ms ease",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    pr: 1,
                    opacity: millBroken ? 0.9 : 1,
                    position: "relative",
                  }}
                >
                  {enOferta && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: 2,
                        right: 3,
                        fontSize: 9,
                        color: "greenyellow",
                        background: "rgba(0,0,0,0.5)",
                        px: 0.4,
                        borderRadius: 0.5,
                      }}
                    >
                      {oferta.etiqueta || "OFFER"}
                    </Box>
                  )}

                  <Typography sx={{ fontSize: 13 }}>
                    {i?.item || nombre} - {safeNum(i?.cantidad)}
                    {receta ? (
                      <span style={{ opacity: 0.75, display: "block", fontSize: 10 }}>
                        Ratio {ratioValue(receta)}
                        {enOferta ? ` (base ${safeNum(receta.ratioBase)})` : ""}
                      </span>
                    ) : null}
                  </Typography>

                  <CardMedia
                    component="img"
                    image={i?.url || SAFE_FALLBACK_ICON}
                    sx={{ width: 18, height: 18, objectFit: "contain", imageRendering: "pixelated" }}
                  />
                </Box>
              );
            })}
          </Grid2>

          <Grid2 xs={12} md={6} sx={{ minHeight: 280 }}>
            <MillScene
              running={running}
              broken={millBroken}
              produceUrl={produceImg}
              title={millBroken ? "MILL BROKEN" : running ? "MILLING…" : "MILL"}
              subtitle={millBroken ? "Repair to continue" : running ? "Grinding materials" : "Idle"}
            />

            <Box
              className="rpgui-container framed-grey"
              sx={{
                mt: 1.2,
                p: 1.2,
                display: "grid",
                gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                gap: 1,
                alignItems: "center",
                opacity: millBroken ? 0.85 : 1,
              }}
            >
              <Box>
                <Typography sx={{ opacity: 0.9, fontSize: 13 }}>Quantity</Typography>
                <input
                  value={cantidad}
                  onBlur={handleCantidad}
                  onChange={(e) => setCantidad(e.target.value)}
                  type="number"
                  min="0"
                  placeholder="Quantity"
                  style={{ width: "100%" }}
                  disabled={millBroken}
                />
                <Typography sx={{ fontSize: 12, opacity: 0.85, mt: 0.6 }}>
                  Min {metaSel?.min} · Max {metaSel?.max}
                </Typography>
              </Box>

              <Box>
                <Typography sx={{ fontSize: 13 }}>
                  Receive: <span style={{ color: "lime" }}>{monto}</span> · {metaSel?.produce}
                </Typography>

                <Typography sx={{ fontSize: 13 }}>
                  Time: <b>{effectiveHoursUI.toFixed(2)}h</b>{" "}
                  <span style={{ opacity: 0.7 }}>
                    (base {safeNum(metaSel?.tiempo)}h · lvl {molinoNivel}
                    {petMillTimeReductionPercent > 0
                      ? ` · pet -${petMillTimeReductionPercent}%`
                      : ""})
                  </span>
                </Typography>

                {petBenefit?.active &&
                  petMillTimeReductionPercent > 0 && (
                    <Typography
                      sx={{
                        fontSize: 11,
                        color: "greenyellow",
                        mt: 0.25,
                      }}
                    >
                      🐾 Active pet benefit: mill processing time reduced by{" "}
                      {petMillTimeReductionPercent}%.
                    </Typography>
                  )}

                <Typography sx={{ fontSize: 12, opacity: 0.85 }}>
                  Ratio {ratioValue(metaSel)} · Energy fee {metaSel?.costo} · Wear -{safeNum(metaSel?.wear)}%
                </Typography>

                {ofertasMolino.some((o) => o.item === selector) && (
                  <Box
                    sx={{
                      mt: 0.55,
                      p: 0.7,
                      borderRadius: 1,
                      border: "1px solid rgba(173,255,47,0.25)",
                      background: "rgba(70,120,20,0.16)",
                    }}
                  >
                    <Typography sx={{ fontSize: 12, color: "greenyellow" }}>
                      🔥 Active offer: ratio {safeNum(metaSel?.ratioBase)} → {ratioValue(metaSel)}
                    </Typography>

                    {ofertasMolino.find((o) => o.item === selector)?.fechaFin && (
                      <OfertaCountdown fechaFin={ofertasMolino.find((o) => o.item === selector)?.fechaFin} />
                    )}
                  </Box>
                )}

                <Box sx={{ mt: 0.8, display: "flex", justifyContent: { xs: "center", sm: "flex-end" }, gap: 1 }}>
                  <motion.div whileTap={{ scale: 0.97 }} whileHover={{ scale: 1.02 }}>
                    <Button
                      onClick={procesar}
                      className="rpgui-button"
                      disabled={isSubmitting || millBroken}
                      sx={{ transform: "scale(0.95)" }}
                    >
                      <p>{millBroken ? "Locked" : isSubmitting ? "..." : "Start"}</p>
                    </Button>
                  </motion.div>
                </Box>
              </Box>
            </Box>
          </Grid2>

          <Grid2
            xs={12}
            md={3}
            className="rpgui-container framed-grey"
            sx={{
              minHeight: 280,
              p: 1.2,
            }}
          >
            <Box className="rpgui-container framed-golden" sx={{ p: 1, width: "100%" }}>
              <Typography sx={{ fontSize: 13, mb: 0.7 }}>
                ⚙️ Mill Level: {molinoNivel}{" "}
                {millBroken ? <span style={{ marginLeft: 8, color: "salmon" }}>· BROKEN</span> : null}
              </Typography>

              <Box sx={{ display: "flex", justifyContent: "center", mb: 0.8 }}>
                <CardMedia
                  component="img"
                  image={LEVEL_IMAGES?.[Math.max(0, previewLevel - 1)]}
                  sx={{ width: "70%", maxHeight: 130, objectFit: "contain" }}
                />
              </Box>

              <Box sx={{ display: "flex", gap: 0.8, overflowX: "auto", pb: 0.6 }}>
                {Array.from({ length: maxLevel }).map((_, i) => {
                  const lvl = i + 1;
                  const isActive = lvl === previewLevel;
                  const isOwned = lvl <= molinoNivel;
                  const isNext = lvl === nextLevelReal;

                  return (
                    <Box
                      key={lvl}
                      onClick={() => setPreviewLevel(lvl)}
                      sx={{
                        minWidth: 52,
                        height: 42,
                        borderRadius: 1,
                        border: isActive
                          ? "2px solid rgba(173,255,47,0.85)"
                          : "1px solid rgba(255,255,255,0.18)",
                        position: "relative",
                        overflow: "hidden",
                        cursor: "pointer",
                        flex: "0 0 auto",
                        opacity: isOwned ? 1 : 0.82,
                      }}
                    >
                      <CardMedia
                        component="img"
                        image={LEVEL_IMAGES?.[i]}
                        sx={{ width: "100%", height: "100%", objectFit: "cover" }}
                      />

                      <Box
                        sx={{
                          position: "absolute",
                          left: 4,
                          top: 4,
                          px: 0.6,
                          py: 0.1,
                          borderRadius: 0.8,
                          background: "rgba(0,0,0,0.55)",
                          color: "white",
                          fontSize: "0.6rem",
                        }}
                      >
                        LVL {lvl}
                      </Box>

                      {isNext && (
                        <Box
                          sx={{
                            position: "absolute",
                            right: 4,
                            bottom: 4,
                            px: 0.5,
                            py: 0.1,
                            borderRadius: 0.8,
                            background: "rgba(173,255,47,0.18)",
                            border: "1px solid rgba(173,255,47,0.35)",
                            color: "greenyellow",
                            fontSize: "0.58rem",
                          }}
                        >
                          NEXT
                        </Box>
                      )}

                      {!isOwned && !isNext && (
                        <Box
                          sx={{
                            position: "absolute",
                            right: 4,
                            bottom: 4,
                            px: 0.5,
                            py: 0.1,
                            borderRadius: 0.8,
                            background: "rgba(0,0,0,0.45)",
                            border: "1px solid rgba(255,255,255,0.12)",
                            color: "rgba(255,255,255,0.85)",
                            fontSize: "0.58rem",
                          }}
                        >
                          LOCK
                        </Box>
                      )}
                    </Box>
                  );
                })}
              </Box>

              {reqForPreviewLevel ? (
                <Box sx={{ mt: 0.6 }}>
                  <Typography sx={{ fontSize: 12, opacity: 0.9 }}>Reqs for LVL {previewLevel}:</Typography>
                  {Object.entries(reqForPreviewLevel)
                    .filter(([k]) => k !== "time")
                    .map(([k, v]) => (
                      <Typography key={k} sx={{ fontSize: 12 }}>
                        {k}: {v}
                      </Typography>
                    ))}
                </Box>
              ) : (
                <Typography sx={{ fontSize: 12, opacity: 0.8, mt: 0.6 }}>
                  Select a higher level to see requirements.
                </Typography>
              )}

              <Box sx={{ mt: 1.0, display: "flex", justifyContent: "center" }}>
                {previewLevel === nextLevelReal && nextLevelReal > molinoNivel ? (
                  <SubirNivelButton
                    selector={{ id: 20, type: "molino" }}
                    reqs={reqForPreviewLevel}
                    setMensaje={setMensaje}
                    setError={setError}
                    setOpen={setOpen}
                    mode="molino"
                  />
                ) : (
                  <Typography sx={{ fontSize: 12, opacity: 0.85 }}>
                    To upgrade, select <b>NEXT</b>.
                  </Typography>
                )}
              </Box>

              <Typography sx={{ fontSize: 12, opacity: 0.75, mt: 0.8, textAlign: "center" }}>
                Bonus: Level reduces processing time server-side.
              </Typography>
            </Box>
          </Grid2>
        </Box>
      )}

      <Alerta mensaje={mensaje} open={open} handleClose={() => setOpen(false)} error={error} />
    </Grid2>
  );
};
